import {
  COMPANY_SWITCHER_WIDTH,
  DRAWER_WIDTH,
  NEW_SIDEBAR_DRAWER_WIDTH,
} from 'src/constants/uiConsts';
import { useFeatureFlags } from 'src/context';
import { useCompanySwitcherVisibility } from 'src/features/companies/useCompanySwitcherVisibility';

export const useDrawerWidth = (): number => {
  const { EnableNewSidebar } = useFeatureFlags();
  const drawerWidth = EnableNewSidebar
    ? NEW_SIDEBAR_DRAWER_WIDTH
    : DRAWER_WIDTH;
  const isSidebarCompanySwitcherVisible = useCompanySwitcherVisibility();
  return isSidebarCompanySwitcherVisible.visibility === 'desktop'
    ? drawerWidth + COMPANY_SWITCHER_WIDTH
    : drawerWidth;
};
